import { Popover as PopoverAntd, PopoverProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

export const Popover = memo(({ overlayClassName, ...rest }: PopoverProps) => (
  <PopoverAntd overlayClassName={classNames('', overlayClassName)} {...rest} />
));

Popover.displayName = 'Popover';
